export enum OrderMutationType {
  SET_ORDER_LIST = 'SET_ORDER_LIST',
  SET_TOTAL_ORDERS = 'SET_TOTAL_ORDERS',
  SET_SAVED_ORDERS = 'SET_SAVED_ORDERS',
  SET_SAVED_ORDER_DETAILS = 'SET_SAVED_ORDER_DETAILS',
  SET_TOTAL_SAVED_ORDERS = 'SET_TOTAL_SAVED_ORDERS',
  SET_LOADING = 'SET_LOADING',
  SET_REORDER_SAVED_ORDER = 'SET_REORDER_SAVED_ORDER',
  SET_DELETE_SAVED_ORDER = 'SET_DELETE_SAVED_ORDER',
  SET_REORDER_HISTORY_ORDER = 'SET_REORDER_HISTORY_ORDER',
  SET_CANCEL_SAVED_ORDER = 'SET_CANCEL_SAVED_ORDER',
  SET_SAVED_ORDER_PAGE_INFO = 'SET_SAVED_ORDER_PAGE_INFO',
  SET_SHIP_TO_FILTER = 'SET_SHIP_TO_FILTER',
  SET_BULK_UPLOAD = 'SET_BULK_UPLOAD',
  SET_ORDER_TRACKING = 'SET_ORDER_TRACKING',
  SET_DELIVERY_PLAN = 'SET_DELIVERY_PLAN',
  SET_PRODUCT_BRANDS = 'SET_PRODUCT_BRANDS',
  SET_PACK_FORMAT = 'SET_PACK_FORMAT',
  SET_SKUS = 'SET_SKUS'

}
